import revive_payload_client_TkEwdC1ioF from "/home/dev/uogorod-src/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_cGdZNAp65c from "/home/dev/uogorod-src/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_FzCZBoSLvg from "/home/dev/uogorod-src/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_9Lu5WyI5ZA from "/home/dev/uogorod-src/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_xu6ORWZvBh from "/home/dev/uogorod-src/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_07QXb26YgB from "/home/dev/uogorod-src/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_UCtoWuuD1k from "/home/dev/uogorod-src/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_97X4ychUZG from "/home/dev/uogorod-src/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/home/dev/uogorod-build-local-fonts-20261103/.nuxt/components.plugin.mjs";
import prefetch_client_i96l1ds3Z5 from "/home/dev/uogorod-src/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_cOFHCanYjb from "/home/dev/uogorod-src/node_modules/nuxt-jsonld/dist/runtime/plugin.js";
import pwa_icons_plugin_LnrhIJeMG7 from "/home/dev/uogorod-build-local-fonts-20261103/.nuxt/pwa-icons-plugin.ts";
import pwa_client_BTdMVDJkdD from "/home/dev/uogorod-src/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.js";
import element_plus_teleports_plugin_h4Dmekbj62 from "/home/dev/uogorod-build-local-fonts-20261103/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_1RNPi6ogby from "/home/dev/uogorod-build-local-fonts-20261103/.nuxt/element-plus-injection.plugin.mjs";
import analytics_boundary_client_Kj8V9FLMwR from "/home/dev/uogorod-build-local-fonts-20261103/plugins/analytics-boundary.client.ts";
import journey_client_vPPP7kOFF9 from "/home/dev/uogorod-build-local-fonts-20261103/plugins/journey.client.ts";
import light404_client_gXAFnwAzXO from "/home/dev/uogorod-build-local-fonts-20261103/plugins/light404.client.ts";
import presence_client_CgM5h7FGiq from "/home/dev/uogorod-build-local-fonts-20261103/plugins/presence.client.ts";
import qrql_Ud7iON44mZ from "/home/dev/uogorod-build-local-fonts-20261103/plugins/qrql.ts";
import route_component_recovery_client_DAXiOpW88A from "/home/dev/uogorod-build-local-fonts-20261103/plugins/route-component-recovery.client.ts";
import yandex_map_client_9cl7nhyqlk from "/home/dev/uogorod-build-local-fonts-20261103/plugins/yandex-map.client.ts";
export default [
  revive_payload_client_TkEwdC1ioF,
  unhead_cGdZNAp65c,
  router_FzCZBoSLvg,
  _0_siteConfig_9Lu5WyI5ZA,
  payload_client_xu6ORWZvBh,
  navigation_repaint_client_07QXb26YgB,
  check_outdated_build_client_UCtoWuuD1k,
  chunk_reload_client_97X4ychUZG,
  components_plugin_KR1HBZs4kY,
  prefetch_client_i96l1ds3Z5,
  plugin_cOFHCanYjb,
  pwa_icons_plugin_LnrhIJeMG7,
  pwa_client_BTdMVDJkdD,
  element_plus_teleports_plugin_h4Dmekbj62,
  element_plus_injection_plugin_1RNPi6ogby,
  analytics_boundary_client_Kj8V9FLMwR,
  journey_client_vPPP7kOFF9,
  light404_client_gXAFnwAzXO,
  presence_client_CgM5h7FGiq,
  qrql_Ud7iON44mZ,
  route_component_recovery_client_DAXiOpW88A,
  yandex_map_client_9cl7nhyqlk
]